"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Form_1 = __importDefault(require("react-bootstrap/Form"));
var FormFieldCheckInputOption = function (props) {
    var id = props.id, value = props.value, placeholder = props.placeholder, controlType = props.controlType, readOnly = props.readOnly, fieldName = props.fieldName, checked = props.checked;
    var _a = __read(react_1.useState(''), 2), inputValue = _a[0], setInputValue = _a[1];
    react_1.useEffect(function () {
        setInputValue(props.inputValue || '');
    }, [props.inputValue]);
    var onChange = function () {
        if (props.onChange) {
            props.onChange(fieldName, value, inputValue);
        }
    };
    var onBlur = function () {
        if (props.onBlur) {
            props.onBlur(fieldName, value, inputValue);
        }
    };
    var updateFieldInputValue = function (e) {
        var element = e.target;
        var _inputValue = element.value ? element.value : '';
        if (props.onChange) {
            props.onChange(fieldName, value, _inputValue);
        }
    };
    return (react_1.default.createElement(Form_1.default.Check, { id: id, inline: true, name: fieldName, value: value, disabled: readOnly, type: controlType, feedback: undefined },
        react_1.default.createElement(Form_1.default.Check.Input, { name: fieldName, type: controlType, isValid: true, value: value, checked: checked, onChange: onChange, onBlur: onBlur }),
        react_1.default.createElement(Form_1.default.Check.Label, null,
            react_1.default.createElement(Form_1.default.Control, { placeholder: placeholder, value: inputValue, onChange: updateFieldInputValue }))));
};
FormFieldCheckInputOption.propTypes = {
    id: prop_types_1.default.string,
    type: prop_types_1.default.string,
    value: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    inputValue: prop_types_1.default.string,
    controlType: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    checked: prop_types_1.default.bool,
    fieldName: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
};
exports.default = FormFieldCheckInputOption;
//# sourceMappingURL=FormFieldCheckInputOption.js.map